export default __webpack_public_path__ + "static/media/WM0060.34I-38002_-22289_0.e95b8e46.jpg";